export type FileParsingStatus = 'pending' | 'processing' | 'completed' | 'failed' | 'unknown'

export const SUPPORTED_FILE_TYPES = ['doc', 'docx', 'pdf', 'xlsx'] as const
export const SUPPORTED_MIME_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]

export type SupportedFileType = (typeof SUPPORTED_FILE_TYPES)[number]
export type SupportedMimeType = (typeof SUPPORTED_MIME_TYPES)[number]

export type FileInfoType = {
  id: string
  name: string
  type: string
  parsingStatus?: FileParsingStatus
  uploadedAt?: string
  expiresAt?: string
  isExcluded: boolean
  errorMessage?: string
}

export type SectionType = 'heading' | 'text' | 'table'

/**
 * Represents an entry in the document hierarchy (heading or table)
 * This applies for both uploaded files and the working document
 */
export interface DocumentSectionTree {
  id: string
  type: SectionType
  title: string
  children: DocumentSectionTree[]
}

export interface RlcpFile {
  id: string
  name: string
  documentId?: string
  version?: string
  versionId?: string
  createdAt?: string
  modifiedAt?: string
  documentUrl?: string
  children: RlcpFile[]
}

export type SelectedRlcpFile = {
  versionId: string
  name: string
}
